import { CheckIcon } from 'lucide-react';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
const SuccessStage = () => {
  const {
    firstName
  } = useGetUserProfileInfo();
  return <div className='grid gap-24 justify-items-center text-[#34d399]' data-sentry-component="SuccessStage" data-sentry-source-file="SuccessStage.tsx">
      <div className='px-4 purple-gradient h-[370px] pt-14'>
        <CheckIcon className='w-20 h-20 text-genius-cream m-auto text-green-400' data-sentry-element="CheckIcon" data-sentry-source-file="SuccessStage.tsx" />

        <div className='font-normal text-[24px] text-center font-mediumu text-genius-cream mt-10'>
          Success!<br></br>
          Way to go, {firstName}.
        </div>
      </div>
    </div>;
};
export default SuccessStage;